module.exports = __webpack_public_path__ + "assets/img/teamClose.c3e31572.svg";